export type RecentItem = { q: string; type?: string; ts: number };
const KEY = 'ng.search.history';
const CAP = 10;

export function getRecent(): RecentItem[] {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '[]');
  } catch {
    return [];
  }
}

export function saveRecent(q: string, type?: string) {
  const list = getRecent().filter((x) => !(x.q === q && x.type === type));
  list.unshift({ q, type, ts: Date.now() });
  localStorage.setItem(KEY, JSON.stringify(list.slice(0, CAP)));
}

export function removeRecent(q: string, type?: string) {
  const list = getRecent().filter((x) => !(x.q === q && x.type === type));
  localStorage.setItem(KEY, JSON.stringify(list));
}

export function clearRecent() {
  localStorage.removeItem(KEY);
}
